module.exports = __webpack_public_path__ + "img/warning.eb3f0118.png";